<div class="error-content">

  <div class="img-agent prima-logo">
    <img src="assets/img/prima-logo.png">
  </div>
  <div class="error-card">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon slot="start" color="error">error_outline</mat-icon>
          Chyba!
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Požadovanou stránku nelze načíst</p>
        <code>{{message}}</code><br><br>
        <button mat-button color="primary" (click)="goHome()">
          <mat-icon slot="start">home</mat-icon> Domů
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
